import mediumProtocolServices from '@/api/protocol/mediumProtocolServices'

export default {
  loadTable({ commit }, pageConfig) {
    return mediumProtocolServices.loadTable(pageConfig).then(result => {
      commit('LOAD_LIST', result.data.content)
      return result
    }).catch(err => err)
  },
  insert({ commit }, data) {
    return mediumProtocolServices.insert(data).then(result => result).catch(error => error)
  },
  prepareToEdit({ commit }, data) {
    commit('PREPARE_TO_EDIT', data)
  },
  edit({ commit }, data) {
    return mediumProtocolServices.edit(data).then(result => result).catch(error => error)
  },
  delete({ commit }, id) {
    return mediumProtocolServices.delete(id).then(result => result).catch(error => error)
  },
}
